import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import PropTypes from "prop-types";
import Select from "Components/select/Select";
import withFormState from "Components/withFormState";
import { alertSuccess, alertError } from "Utils/alerts";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import { withRouter } from "react-router-dom";
import qs from "query-string";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import cx from "classnames";
import s from "./ownershipCheckEmail.scss";

const initFormValues = {
  verification_email_address: "",
  possession_a_record: "",
};

class OwnershipCheckEmail extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.setInitialValues({
      verification_email_address: `postmaster@${this.props.domainName}`,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.hasValidationSuccessed) {
      this.props.history.push("/domains");
      alertSuccess(t("alert.ownershipCheckSuccess"));
    } else if (nextProps.hasValidationFailed && !nextProps.isCodeVerifing && this.props.isCodeVerifing) {
      alertError(t("alert.code.notValid"));
    } else if (!this.props.isCodeSent && nextProps.isCodeSent) {
      alertSuccess(`${t("alert.ownershipEmailSent")} ${nextProps.emailChosen.toLowerCase()}`);
    }
  }

  verifyCode(e) {
    e.preventDefault();
    this.props.verifyCode(
      this.props.domainCode,
      {
        possession_a_record: this.props.formData.possession_a_record,
      },
      this.props.aliasDomainCode
    );
  }

  sendVerificationEmail(e) {
    e.preventDefault();
    this.props.sendVerificationEmail(
      this.props.domainCode,
      {
        verification_email_address: this.props.formData.verification_email_address,
      },
      this.props.aliasDomainCode
    );
  }

  resetEmailVerification() {
    this.props.resetDomainEmailVerificationStatusDetail(this.props.domainCode);
    this.props.resetEmailVerification(this.props.domainCode);
  }

  renderCodeInput(chosenAddres, buttonStatus) {
    return (
      <div className={s.ownershipCheckEmail}>
        <div className={s.text}>
          <TranslatedString subs={{ emailAddress: chosenAddres }}>
            ownershipCheck.email.instruction.part2
          </TranslatedString>
        </div>
        <form className={s.form} method="post" onSubmit={this.verifyCode.bind(this)}>
          <Input
            value={this.props.formData.possession_a_record}
            onChange={this.props.setFormFieldValue}
            name="possession_a_record"
            label={t("input.label.verify.code")}
            placeholder=" "
            required
          />
          <div className={s.footer}>
            <Button color="outline" onClick={this.resetEmailVerification.bind(this)}>
              button.resetProcedure
            </Button>

            <div className={s.btnRight}>
              <Button color="text" onClick={() => this.props.resetAndGoBack()}>
                button.cancel
              </Button>
              <Button type="submit" loading={buttonStatus}>
                button.verify
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }

  renderEmailSelection(emails, buttonStatus) {
    return (
      <div className={s.ownershipCheckEmail}>
        <div className={s.text}>
          <TranslatedString>ownershipCheck.email.instruction.part1</TranslatedString>
        </div>

        <form className={s.form} method="post" onSubmit={this.sendVerificationEmail.bind(this)}>
          <Select
            label={t("input.label.select.verificationEmail")}
            components={{ DropdownIndicator }}
            name="verification_email_address"
            value={this.props.formData.verification_email_address}
            onChange={this.props.setFormFieldValue}
            options={emails}
            clearable={false}
          />

          <div className={s.footer}>
            <div className={s.btnRight}>
              <Button color="text" onClick={() => this.props.resetAndGoBack()}>
                button.cancel
              </Button>
              <Button type="submit" loading={buttonStatus}>
                button.sendVerifyEmail
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
  render() {
    const { isCodeSent, emailChosen, isCodeVerifing, emails, isSendingEmail, domainName } = this.props;
    if (isCodeSent) {
      return this.renderCodeInput(emailChosen, isCodeVerifing);
    }
    let ems = _.map(emails, (name) => ({
      value: `${name}@${domainName}`,
      label: `${name}@${domainName}`,
    }));

    return this.renderEmailSelection(ems, isSendingEmail);
  }
}

export default withRouter(withFormState(OwnershipCheckEmail, initFormValues));
